export enum Permissions {
  // RCS Permissions
  RCS_Apps_All = 'rcs.app.all',
  RCS_Apps_Rc_Access = 'rcs.app.rc',
  RCS_Apps_Bwc_Access = 'rcs.app.bwc',
  RCS_Apps_Mobile_Access = 'rcs.app.mob',
  RCS_Apps_Obstacle_Access = 'rcs.app.obs',
  RCS_Apps_Customer_Access = 'rcs.app.cust',
  RCS_Apps_Simulation_Access = 'rcs.app.sim',
  RCS_Apps_Simulation_Extended_Access = 'rcs.app.sim.ext',
  RCS_Warnings_All_Read = 'rcs.warn.all.r',
  RCS_Warnings_Bdv_Read = 'rcs.warn.bdv.r',
  RCS_Warnings_Va_Read = 'rcs.warn.va.r',
  RCS_Warnings_Lv_Read = 'rcs.warn.lv.r',
  RCS_Warnings_Tl_Read = 'rcs.warn.tl.r',
  RCS_Warnings_Sw_Read = 'rcs.warn.sw.r',
  RCS_Warnings_Hr_Read = 'rcs.warn.hr.r',
  RCS_Warnings_Hs_Read = 'rcs.warn.hs.r',
  RCS_Warnings_Cs_Read = 'rcs.warn.cs.r',
  RCS_Warnings_Pr_Read = 'rcs.warn.pr.r',
  RCS_Warnings_Wwd_Read = 'rcs.warn.wwd.r',
  RCS_Warnings_Ior_Read = 'rcs.warn.ior.r',
  RCS_Warnings_Al_Read = 'rcs.warn.al.r',
  RCS_Warnings_Bl_Read = 'rcs.warn.bl.r',
  RCS_Warnings_Sv_Read = 'rcs.warn.sv.r',
  RCS_Warnings_Tjt_Read = 'rcs.warn.tjt.r',
  RCS_Warnings_Bdv_Write = 'rcs.warn.bdv.w',
  RCS_Warnings_Va_Write = 'rcs.warn.va.w',
  RCS_Warnings_Lv_Write = 'rcs.warn.lv.w',
  RCS_Warnings_Tl_Write = 'rcs.warn.tl.w',
  RCS_Warnings_Sw_Write = 'rcs.warn.sw.w',
  RCS_Warnings_Hr_Write = 'rcs.warn.hr.w',
  RCS_Warnings_Hs_Write = 'rcs.warn.hs.w',
  RCS_Warnings_Cs_Write = 'rcs.warn.cs.w',
  RCS_Warnings_Pr_Write = 'rcs.warn.pr.w',
  RCS_Warnings_Wwd_Write = 'rcs.warn.wwd.w',
  RCS_Warnings_Ior_Write = 'rcs.warn.ior.w',
  RCS_Warnings_Al_Write = 'rcs.warn.al.w',
  RCS_Warnings_Bl_Write = 'rcs.warn.bl.w',
  RCS_Warnings_Sv_Write = 'rcs.warn.sv.w',
  RCS_Warnings_Tjt_Write = 'rcs.warn.tjt.w',
  RCS_Hazards_All_Read = 'rcs.hz.all.r',
  RCS_RoadSegments_All_Read = 'rcs.rs.all.r',
  RCS_RoadSegments_Rc_Read = 'rcs.rs.rc.r',
  RCS_Historic_All_Read = 'rcs.historic.all.r',
  RCS_Historic_Warnings_Read = 'rcs.historic.warnings.r',
  RCS_Weather_All_Read = 'rcs.wp.all.r',
  RCS_Admin = 'rcs.admin',
  RCS_Preview_Feature_Flag = 'rcs.preview.flag.w',
}

export const DefaultAadPermissions = [
  Permissions.RCS_Warnings_All_Read,
  Permissions.RCS_Hazards_All_Read,
  Permissions.RCS_RoadSegments_All_Read,
  Permissions.RCS_Weather_All_Read,
  Permissions.RCS_Apps_All,
]
